import {
  SurveyValidator,
  SurveyValidatorResult
} from 'core/builder/validators/SurveyValidator'
import {
  SurveyElement,
  SurveyElementChoices,
  SurveyElementTimePicker
} from 'core/SurveyModels'

export class SurveyValidatorBasicAttribute extends SurveyValidator {
  result(): Promise<SurveyValidatorResult[]> {
    const result: SurveyValidatorResult[] = []
    this.survey.pages.forEach((page) => {
      // Missing attributes
      const checkForInvalidAttributes = (el: SurveyElement): boolean => {
        if (!el.name || !el.title?.['en']) return true
        if (
          ['dropdown', 'choices'].includes(el.type) &&
          ((el as SurveyElementChoices).choices ?? []).length === 0
        )
          return true
        return (
          el.type === 'time-picker' &&
          ((el as SurveyElementTimePicker).ranges ?? []).length === 0
        )
      }
      page.elements.filter(checkForInvalidAttributes).forEach((element) => {
        result.push({
          pageName: page.name,
          elementName: element.name,
          level: 'ERROR',
          description: 'Missing name, title, choices or time ranges'
        })
      })

      // Duplicated choices if any
      page.elements
        .filter((element) =>
          ['dropdown', 'choices', 'time-picker'].includes(element.type)
        )
        .forEach((element) => {
          const hasDuplicates = (t: string[]) => {
            return t.length !== new Set(t).size
          }
          if (
            element.type === 'time-picker' &&
            hasDuplicates(
              (element as SurveyElementTimePicker)?.ranges?.map((r) =>
                r.join('-')
              ) ?? []
            )
          ) {
            result.push({
              pageName: page.name,
              elementName: element.name,
              level: 'ERROR',
              description: 'There is duplicated time ranges'
            })
          }
          if (
            element.type !== 'time-picker' &&
            hasDuplicates(
              (element as SurveyElementChoices)?.choices?.map((ch) =>
                ch.value.toString()
              ) ?? []
            )
          ) {
            result.push({
              pageName: page.name,
              elementName: element.name,
              level: 'ERROR',
              description: 'There is duplicated choices'
            })
          }
        })
    })
    return Promise.resolve(result)
  }
}
